import React from "react";

import PageLayout from "$src/core/components/templates/PageLayout";
import ProfilesPage from "$src/core/pages/ProfilesPage/ProfilesPage";

const Route: React.FC = () => (
  <PageLayout>
    <ProfilesPage />
  </PageLayout>
);

export default Route;
